import type { QueryClient } from "@tanstack/react-query";
import { notFound, createFileRoute } from "@tanstack/react-router";

import { apiErrorStatus, isApiError } from "@/core/lib/api-errors";
import { getOrganizationUserProfileOptions } from "@/openapi/@tanstack/react-query.gen";

export async function loadOrganizationUser({
  queryClient,
  orgId,
  userId,
  signal,
}: {
  queryClient: Pick<QueryClient, "query">;
  orgId: string;
  userId: string;
  signal: AbortSignal;
}) {
  try {
    const user = await queryClient.query({
      ...getOrganizationUserProfileOptions({
        path: {
          org_id: orgId,
          user_id: userId,
        },
        signal,
      }),
      staleTime: Infinity,
    });

    return { user };
  } catch (error) {
    if (isApiError(error) && apiErrorStatus(error) === 404) {
      throw notFound();
    }
    throw error;
  }
}

export const Route = createFileRoute(
  "/_protected/organization/$orgId/user/$userId/",
)({
  loader: async ({ context: { queryClient }, params, abortController }) =>
    loadOrganizationUser({
      queryClient,
      orgId: params.orgId,
      userId: params.userId,
      signal: abortController.signal,
    }),
});
